<template>
  <Header />
  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in">
      <component
        :is="Component"
        :key="$route.matched[0]?.path"
      />
    </transition>
  </router-view>
</template>

<script setup>
import { Header } from '@widgets/header'
</script>